module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-left-arrow-gray-light-on-white-be06883ee84a9459969eb9c11b55c189.svg";